import Content from "./Content.svelte";
import Divider from "./Divider.svelte";
import Item from "./Item.svelte";
import Root from "./Root.svelte";
import SearchableList from "./SearchableList.svelte";
import SubContent from "./SubContent.svelte";
import SubTrigger from "./SubTrigger.svelte";
import Trigger from "./Trigger.svelte";
export const Menu = Object.assign(Root, {
    Content,
    Trigger,
    Item,
    SubContent,
    SubTrigger,
    Divider,
    SearchableList,
});
